/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        key: "tips",
        value: "店铺链接可以拖拽改变顺序",
        type: "tips"
    },
    {
        name: "店铺",
        type: "module-name"
    },
    {
        key: "link_data",
        name: "链接",
        type: "shop-list"
    }
];

export default config;